module.exports = __webpack_public_path__ + "img/checkmark-circle.a0ed1728.svg";